/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminStudentDetailDTO,
  AdminStudentListItemDTOQueryResultDTO,
  AdminStudentsGetAdminStudentsForOrganizationParams,
  AdminStudentsImportStudentsBody,
  AdminStudentsImportStudentsParams,
  ExportStudentsRequestDTO,
  FilterModelDTO,
  ImportResultDTO,
  QueryColumnConfigDTO,
  UpsertAdminStudentDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminStudentsGetAdminStudentsForOrganization = (
    organizationId: number,
    filterModelDTO: FilterModelDTO[],
    params?: AdminStudentsGetAdminStudentsForOrganizationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminStudentListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminStudents/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getAdminStudentsGetAdminStudentsForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentsForOrganization>>, TError,{organizationId: number;data: FilterModelDTO[];params?: AdminStudentsGetAdminStudentsForOrganizationParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentsForOrganization>>, TError,{organizationId: number;data: FilterModelDTO[];params?: AdminStudentsGetAdminStudentsForOrganizationParams}, TContext> => {
    
const mutationKey = ['adminStudentsGetAdminStudentsForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStudentsGetAdminStudentsForOrganization>>, {organizationId: number;data: FilterModelDTO[];params?: AdminStudentsGetAdminStudentsForOrganizationParams}> = (props) => {
          const {organizationId,data,params} = props ?? {};

          return  adminStudentsGetAdminStudentsForOrganization(organizationId,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminStudentsGetAdminStudentsForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminStudentsGetAdminStudentsForOrganization>>>
    export type AdminStudentsGetAdminStudentsForOrganizationMutationBody = FilterModelDTO[]
    export type AdminStudentsGetAdminStudentsForOrganizationMutationError = ErrorType<unknown>

    export const useAdminStudentsGetAdminStudentsForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentsForOrganization>>, TError,{organizationId: number;data: FilterModelDTO[];params?: AdminStudentsGetAdminStudentsForOrganizationParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStudentsGetAdminStudentsForOrganization>>,
        TError,
        {organizationId: number;data: FilterModelDTO[];params?: AdminStudentsGetAdminStudentsForOrganizationParams},
        TContext
      > => {

      const mutationOptions = getAdminStudentsGetAdminStudentsForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminStudentsGetAdminStudentFilterConfig = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<QueryColumnConfigDTO[]>(
      {url: `/api/organizations/${organizationId}/admin/AdminStudents/filter-config`, method: 'GET', signal
    },
      );
    }
  

export const getAdminStudentsGetAdminStudentFilterConfigQueryKey = (organizationId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminStudents/filter-config`] as const;
    }

    
export const getAdminStudentsGetAdminStudentFilterConfigQueryOptions = <TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminStudentsGetAdminStudentFilterConfigQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>> = ({ signal }) => adminStudentsGetAdminStudentFilterConfig(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminStudentsGetAdminStudentFilterConfigQueryResult = NonNullable<Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>>
export type AdminStudentsGetAdminStudentFilterConfigQueryError = ErrorType<unknown>


export function useAdminStudentsGetAdminStudentFilterConfig<TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminStudentsGetAdminStudentFilterConfig<TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminStudentsGetAdminStudentFilterConfig<TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminStudentsGetAdminStudentFilterConfig<TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminStudentsGetAdminStudentFilterConfigQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminStudentsGetAdminStudentDetail = (
    organizationId: number,
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminStudentDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminStudents/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminStudentsGetAdminStudentDetailQueryKey = (organizationId: number,
    id: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminStudents/${id}`] as const;
    }

    
export const getAdminStudentsGetAdminStudentDetailQueryOptions = <TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError = ErrorType<unknown>>(organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminStudentsGetAdminStudentDetailQueryKey(organizationId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>> = ({ signal }) => adminStudentsGetAdminStudentDetail(organizationId,id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminStudentsGetAdminStudentDetailQueryResult = NonNullable<Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>>
export type AdminStudentsGetAdminStudentDetailQueryError = ErrorType<unknown>


export function useAdminStudentsGetAdminStudentDetail<TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>,
          TError,
          Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminStudentsGetAdminStudentDetail<TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>,
          TError,
          Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminStudentsGetAdminStudentDetail<TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminStudentsGetAdminStudentDetail<TData = Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStudentsGetAdminStudentDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminStudentsGetAdminStudentDetailQueryOptions(organizationId,id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminStudentsUpdateStudentForOrganization = (
    organizationId: number,
    id: number,
    upsertAdminStudentDTO: UpsertAdminStudentDTO,
 ) => {
      
      
      return customInstance<AdminStudentDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminStudents/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminStudentDTO
    },
      );
    }
  


export const getAdminStudentsUpdateStudentForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsUpdateStudentForOrganization>>, TError,{organizationId: number;id: number;data: UpsertAdminStudentDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminStudentsUpdateStudentForOrganization>>, TError,{organizationId: number;id: number;data: UpsertAdminStudentDTO}, TContext> => {
    
const mutationKey = ['adminStudentsUpdateStudentForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStudentsUpdateStudentForOrganization>>, {organizationId: number;id: number;data: UpsertAdminStudentDTO}> = (props) => {
          const {organizationId,id,data} = props ?? {};

          return  adminStudentsUpdateStudentForOrganization(organizationId,id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminStudentsUpdateStudentForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminStudentsUpdateStudentForOrganization>>>
    export type AdminStudentsUpdateStudentForOrganizationMutationBody = UpsertAdminStudentDTO
    export type AdminStudentsUpdateStudentForOrganizationMutationError = ErrorType<unknown>

    export const useAdminStudentsUpdateStudentForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsUpdateStudentForOrganization>>, TError,{organizationId: number;id: number;data: UpsertAdminStudentDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStudentsUpdateStudentForOrganization>>,
        TError,
        {organizationId: number;id: number;data: UpsertAdminStudentDTO},
        TContext
      > => {

      const mutationOptions = getAdminStudentsUpdateStudentForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminStudentsDeleteStudentForOrganization = (
    organizationId: number,
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminStudents/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminStudentsDeleteStudentForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsDeleteStudentForOrganization>>, TError,{organizationId: number;id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminStudentsDeleteStudentForOrganization>>, TError,{organizationId: number;id: number}, TContext> => {
    
const mutationKey = ['adminStudentsDeleteStudentForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStudentsDeleteStudentForOrganization>>, {organizationId: number;id: number}> = (props) => {
          const {organizationId,id} = props ?? {};

          return  adminStudentsDeleteStudentForOrganization(organizationId,id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminStudentsDeleteStudentForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminStudentsDeleteStudentForOrganization>>>
    
    export type AdminStudentsDeleteStudentForOrganizationMutationError = ErrorType<unknown>

    export const useAdminStudentsDeleteStudentForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsDeleteStudentForOrganization>>, TError,{organizationId: number;id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStudentsDeleteStudentForOrganization>>,
        TError,
        {organizationId: number;id: number},
        TContext
      > => {

      const mutationOptions = getAdminStudentsDeleteStudentForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminStudentsCreateStudentForOrganization = (
    organizationId: number,
    upsertAdminStudentDTO: UpsertAdminStudentDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminStudentDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminStudents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminStudentDTO, signal
    },
      );
    }
  


export const getAdminStudentsCreateStudentForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsCreateStudentForOrganization>>, TError,{organizationId: number;data: UpsertAdminStudentDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminStudentsCreateStudentForOrganization>>, TError,{organizationId: number;data: UpsertAdminStudentDTO}, TContext> => {
    
const mutationKey = ['adminStudentsCreateStudentForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStudentsCreateStudentForOrganization>>, {organizationId: number;data: UpsertAdminStudentDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminStudentsCreateStudentForOrganization(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminStudentsCreateStudentForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminStudentsCreateStudentForOrganization>>>
    export type AdminStudentsCreateStudentForOrganizationMutationBody = UpsertAdminStudentDTO
    export type AdminStudentsCreateStudentForOrganizationMutationError = ErrorType<unknown>

    export const useAdminStudentsCreateStudentForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsCreateStudentForOrganization>>, TError,{organizationId: number;data: UpsertAdminStudentDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStudentsCreateStudentForOrganization>>,
        TError,
        {organizationId: number;data: UpsertAdminStudentDTO},
        TContext
      > => {

      const mutationOptions = getAdminStudentsCreateStudentForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminStudentsAddChildAsStudent = (
    organizationId: number,
    childId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminStudents/add-child/${childId}`, method: 'POST', signal
    },
      );
    }
  


export const getAdminStudentsAddChildAsStudentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsAddChildAsStudent>>, TError,{organizationId: number;childId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminStudentsAddChildAsStudent>>, TError,{organizationId: number;childId: number}, TContext> => {
    
const mutationKey = ['adminStudentsAddChildAsStudent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStudentsAddChildAsStudent>>, {organizationId: number;childId: number}> = (props) => {
          const {organizationId,childId} = props ?? {};

          return  adminStudentsAddChildAsStudent(organizationId,childId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminStudentsAddChildAsStudentMutationResult = NonNullable<Awaited<ReturnType<typeof adminStudentsAddChildAsStudent>>>
    
    export type AdminStudentsAddChildAsStudentMutationError = ErrorType<unknown>

    export const useAdminStudentsAddChildAsStudent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsAddChildAsStudent>>, TError,{organizationId: number;childId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStudentsAddChildAsStudent>>,
        TError,
        {organizationId: number;childId: number},
        TContext
      > => {

      const mutationOptions = getAdminStudentsAddChildAsStudentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminStudentsImportStudents = (
    organizationId: number,
    adminStudentsImportStudentsBody: AdminStudentsImportStudentsBody,
    params?: AdminStudentsImportStudentsParams,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(adminStudentsImportStudentsBody.file !== undefined) {
 formData.append('file', adminStudentsImportStudentsBody.file)
 }

      return customInstance<ImportResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminStudents/import-students`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params, signal
    },
      );
    }
  


export const getAdminStudentsImportStudentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsImportStudents>>, TError,{organizationId: number;data: AdminStudentsImportStudentsBody;params?: AdminStudentsImportStudentsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminStudentsImportStudents>>, TError,{organizationId: number;data: AdminStudentsImportStudentsBody;params?: AdminStudentsImportStudentsParams}, TContext> => {
    
const mutationKey = ['adminStudentsImportStudents'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStudentsImportStudents>>, {organizationId: number;data: AdminStudentsImportStudentsBody;params?: AdminStudentsImportStudentsParams}> = (props) => {
          const {organizationId,data,params} = props ?? {};

          return  adminStudentsImportStudents(organizationId,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminStudentsImportStudentsMutationResult = NonNullable<Awaited<ReturnType<typeof adminStudentsImportStudents>>>
    export type AdminStudentsImportStudentsMutationBody = AdminStudentsImportStudentsBody
    export type AdminStudentsImportStudentsMutationError = ErrorType<unknown>

    export const useAdminStudentsImportStudents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsImportStudents>>, TError,{organizationId: number;data: AdminStudentsImportStudentsBody;params?: AdminStudentsImportStudentsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStudentsImportStudents>>,
        TError,
        {organizationId: number;data: AdminStudentsImportStudentsBody;params?: AdminStudentsImportStudentsParams},
        TContext
      > => {

      const mutationOptions = getAdminStudentsImportStudentsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminStudentsExportEnrolledStudentsWithParents = (
    organizationId: number,
    exportStudentsRequestDTO: ExportStudentsRequestDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminStudents/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportStudentsRequestDTO, signal
    },
      );
    }
  


export const getAdminStudentsExportEnrolledStudentsWithParentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsExportEnrolledStudentsWithParents>>, TError,{organizationId: number;data: ExportStudentsRequestDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminStudentsExportEnrolledStudentsWithParents>>, TError,{organizationId: number;data: ExportStudentsRequestDTO}, TContext> => {
    
const mutationKey = ['adminStudentsExportEnrolledStudentsWithParents'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStudentsExportEnrolledStudentsWithParents>>, {organizationId: number;data: ExportStudentsRequestDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminStudentsExportEnrolledStudentsWithParents(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminStudentsExportEnrolledStudentsWithParentsMutationResult = NonNullable<Awaited<ReturnType<typeof adminStudentsExportEnrolledStudentsWithParents>>>
    export type AdminStudentsExportEnrolledStudentsWithParentsMutationBody = ExportStudentsRequestDTO
    export type AdminStudentsExportEnrolledStudentsWithParentsMutationError = ErrorType<unknown>

    export const useAdminStudentsExportEnrolledStudentsWithParents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStudentsExportEnrolledStudentsWithParents>>, TError,{organizationId: number;data: ExportStudentsRequestDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStudentsExportEnrolledStudentsWithParents>>,
        TError,
        {organizationId: number;data: ExportStudentsRequestDTO},
        TContext
      > => {

      const mutationOptions = getAdminStudentsExportEnrolledStudentsWithParentsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    